import React from 'react';
import { Calendar, MessageSquare, Share2, Globe, Users, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PhotoCard } from '../UI/PhotoCard';
import restoCardPhotos from '../../config/restoCardPhotos.json';

export const FeaturesResto: React.FC = () => {
  const { t } = useTranslation(['resto', 'home']);
  const { opacity, opacityHover, features: photos } = restoCardPhotos;

  const features = [
    {
      key: 'reservations' as const,
      icon: Calendar,
      title: t('resto:features.reservations.title'),
      description: t('resto:features.reservations.desc'),
    },
    {
      key: 'crm' as const,
      icon: MessageSquare,
      title: t('resto:features.crm.title'),
      description: t('resto:features.crm.desc'),
    },
    {
      key: 'marketing' as const,
      icon: Share2,
      title: t('resto:features.marketing.title'),
      description: t('resto:features.marketing.desc'),
    },
    {
      key: 'website' as const,
      icon: Globe,
      title: t('resto:features.website.title'),
      description: t('resto:features.website.desc'),
    },
    {
      key: 'recruitment' as const,
      icon: Users,
      title: t('resto:features.recruitment.title'),
      description: t('resto:features.recruitment.desc'),
    },
    {
      key: 'performance' as const,
      icon: Star,
      title: t('resto:features.performance.title'),
      description: t('resto:features.performance.desc'),
    },
  ];

  return (
    <section className="py-20 bg-white dark:bg-komby-yellow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('resto:features.sectionTitle')}
          </h2>
          <p className="text-xl text-gray-800 max-w-3xl mx-auto leading-relaxed">
            {t('resto:features.sectionSubtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <PhotoCard
              key={feature.key}
              imageSrc={photos[feature.key]}
              opacity={opacity}
              opacityHover={opacityHover}
              className="text-center min-h-[17rem]"
            >
              <div className="flex h-full flex-col items-center justify-center">
                <div className="mb-4 rounded-full border border-yellow-400/40 bg-black/35 p-4 backdrop-blur-sm">
                  <feature.icon className="h-8 w-8 text-yellow-400" />
                </div>
                <h3 className="mb-2 text-xl font-semibold text-white">
                  {feature.title}
                </h3>
                <p className="text-gray-200">
                  {feature.description}
                </p>
              </div>
            </PhotoCard>
          ))}
        </div>
      </div>
    </section>
  );
};
